import styled from "styled-components";
import { Calendar, DatePicker } from "antd";
import { ContainerRow } from "../Container";
import { useEffect, useState } from "react";
import moment from "moment";
import { useApp } from "../../contexts";

export const DatePickerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  z-index: 100;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;

  @media screen and (max-width: 1024px) {
    & {
    }
  }
`;
export const DatePickerContainerBg = styled.div`
  background: rgba(0, 0, 0, 0.5);
  z-index: 11;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  position: absolute;
`;
export const DatePickerContainerContent = styled.div`
  background: #ffffff;
  box-shadow: 0px 16px 36px rgba(104, 109, 132, 0.4157);
  border-radius: 30px;
  z-index: 12;
  position: relative;
  padding: 50px;

  @media screen and (max-width: 1024px) {
    & {
      width: 100%;
      height: 100%;
      border-radius: 0;
      padding: 44px 20px;
    }
  }
`;
export const DatePickerContainerTitle = styled.div`
  font-weight: 500;
  font-size: 25px;
  line-height: 30px;
  text-align: center;
  letter-spacing: -0.96px;

  margin-bottom: 31px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media screen and (max-width: 1024px) {
    & {
      background: unset;
      text-fill-color: unset;
      -webkit-background-clip: unset;
      -webkit-text-fill-color: unset;
      background-clip: unset;
      color: black;
      text-align: left;
      font-weight: 700;
      font-size: 24px;
      justify-content: flex-start;

      & svg {
        margin-right: 12px;
      }
    }
  }
`;

export const DateRow = styled.div`
  display: flex;
`;
export const DateLabel = styled.div`
  display: flex;
  flex: 1;
  font-weight: 400;
  font-size: 16px;
  line-height: 25px;
  color: #818181;
  margin-bottom: 21px;
`;
const DateSelectHead = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
`;
const DateSelectHeadLeft = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;
const DateSelectHeadRight = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;
const DateSelectHeadIcon = styled.div`
  cursor: pointer;
`;
const DateSelectHeadMonth = styled.div`
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
  color: #000000;
  margin-right: 6px;
`;
const DateSelectHeadYear = styled.div`
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
  color: #000000;
  margin-right: 6px;
`;

export const DateItem = styled.div`
  font-weight: 700;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.7);
  cursor: pointer;
  line-height: 40px;
  width: 40px;
  height: 40px;
  margin: 0 auto;

  &.disabled {
    color: #bebebe;
    cursor: default;
  }

  &.range-view {
    //background: #096dd917;
    border-radius: 40px;
    color: #6b6b6b;
  }

  &.out-range {
    color: #000000;
  }

  &.out-month {
    opacity: 0.3;
  }

  &.active {
    background: #393db8;
    border-radius: 40px;
    color: #fff;
  }

  &.in-range {
    position: relative;
  }

  &.in-range:after {
    position: absolute;
    width: 34px;
    height: 34px;
    background-color: rgba(9, 109, 217, 0.09);
    top: 3px;
    left: 3px;
    content: "";
    border-radius: 20px;
  }
`;

const Date2 = (props) => {
  const [current, setCurrent] = useState();
  const [viewDate, setViewDate] = useState();
  const { T } = useApp();
  const minDate = props.minDate;
  const maxDate = props.maxDate;
  const mode = props.mode;

  useEffect(() => {
    setCurrent(props.value);
    setViewDate(props.value);
    moment.updateLocale("en", {
      weekdaysMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"].map((item) =>
        T(item)
      ),
    });
  }, [props.value]);

  return current && viewDate ? (
    <Calendar
      {...{
        style: props.style,
        className: props.className,
        fullscreen: props.fullscreen,
      }}
      headerRender={({ value, type, onChange, onTypeChange }) => {
        return (
          <DateSelectHead>
            <DateSelectHeadLeft>
              <DateSelectHeadMonth>{value.year()}</DateSelectHeadMonth>
              <DateSelectHeadYear>{T(value.format("MMMM"))}</DateSelectHeadYear>
            </DateSelectHeadLeft>
            <DateSelectHeadRight>
              <DateSelectHeadIcon
                onClick={() => onChange(value.clone().subtract(1, "month"))}
              >
                <svg
                  width="9"
                  height="14"
                  viewBox="0 0 9 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.49474 1.00037L1.83789 6.65723L7.49474 12.3141"
                    stroke="#000000"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </DateSelectHeadIcon>
              <ContainerRow style={{ width: 18 }} />
              <DateSelectHeadIcon
                onClick={() => onChange(value.clone().add(1, "month"))}
              >
                <svg
                  width="9"
                  height="14"
                  viewBox="0 0 9 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1.80799 1.00037L7.46484 6.65723L1.80799 12.3141"
                    stroke="#000000"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </DateSelectHeadIcon>
            </DateSelectHeadRight>
          </DateSelectHead>
        );
      }}
      defaultValue={current}
      onChange={setViewDate}
      dateFullCellRender={(date) => {
        return (
          <DateItem
            className={`
                              ${viewDate.format("MM/YYYY") !==
                date.format("MM/YYYY")
                ? "out-month"
                : ""
              }
                                    ${current.format("DD/MM/YYYY") ===
                date.format("DD/MM/YYYY")
                ? "active"
                : ""
              }
                                    ${mode === "min" &&
                date.format("DD/MM/YYYY") ===
                maxDate.format("DD/MM/YYYY")
                ? "range-view"
                : ""
              }
                                    ${mode === "max" &&
                date.format("DD/MM/YYYY") ===
                minDate.format("DD/MM/YYYY")
                ? "range-view"
                : ""
              }
                                    ${date.toDate().getTime() >
                maxDate.toDate().getTime() ||
                date.toDate().getTime() <
                minDate.toDate().getTime()
                ? "out-range"
                : "in-range"
              }
                              `}
            onClick={() => {
              if (
                mode === "min" &&
                date.toDate().getTime() <= maxDate.toDate().getTime()
              ) {
                setCurrent(date);
                props.onSelect(date);
              }
              if (
                mode === "max" &&
                date.toDate().getTime() >= minDate.toDate().getTime()
              ) {
                setCurrent(date);
                props.onSelect(date);
              }
            }}
          >
            {date.format("DD")}
          </DateItem>
        );
      }}
    />
  ) : null;
};

export const DateSelect = styled(Date2).attrs({
  fullscreen: false,
})`
  width: 360px;
  background: #ffffff;
  box-shadow: 0px 10px 30px rgba(77, 103, 193, 0.14902);
  border-radius: 32px;
  overflow: hidden;

  & .ant-picker-cell .ant-picker-cell-inner {
    font-weight: 500;
    font-size: 14px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #707070;
    width: 40px;
    height: 40px;
    justify-content: center;
    border-radius: 20px;
    border: none !important;
    margin: 0 auto !important;
  }

  & .ant-picker-cell {
    width: 40px;
    height: 40px;
    padding: 0;
  }

  &
    .ant-picker-cell-in-view.ant-picker-cell-today
    .ant-picker-cell-inner::before {
    border: none;
  }

  & .ant-picker-cell-in-view.ant-picker-cell-selected .ant-picker-cell-inner {
    color: white;
    background: #4d67c1;
  }

  & .ant-picker-date-panel .ant-picker-content th {
    width: 40px;
    height: 40px;
    font-weight: 500;
    font-size: 14px;
    text-align: center;
    color: #000000;
  }

  & .ant-picker-cell-disabled::before {
    display: none;
  }

  & .ant-picker-cell-disabled {
    opacity: 1;
    color: #707070;
  }

  @media screen and (max-width: 1024px) {
    & {
      width: 100%;
    }
  }
`;

export const BackIcon = () => (
  <svg
    width="9"
    height="14"
    viewBox="0 0 9 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.64073 1.64073L3.28106 7L8.64073 12.3593L6.9996 14L0 7L7 0L8.64073 1.64073Z"
      fill="#707070"
    />
  </svg>
);
export const Back2Icon = (props) => (
  <svg
    {...props}
    width="9"
    height="14"
    viewBox="0 0 9 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.64073 1.64073L3.28106 7L8.64073 12.3593L6.9996 14L0 7L7 0L8.64073 1.64073Z"
      fill="white"
    />
  </svg>
);
export const Close2Icon = (props) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 6L6 18"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 6L18 18"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Close3Icon = (props) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.1615 3.55078L3.7373 17.975"
      stroke="black"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M3.7373 3.55078L18.1615 17.975"
      stroke="black"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const DateIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.6667 2.66699H3.33333C2.59695 2.66699 2 3.26395 2 4.00033V13.3337C2 14.07 2.59695 14.667 3.33333 14.667H12.6667C13.403 14.667 14 14.07 14 13.3337V4.00033C14 3.26395 13.403 2.66699 12.6667 2.66699Z"
      stroke="#707070"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.667 1.33301V3.99967"
      stroke="#707070"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.33301 1.33301V3.99967"
      stroke="#707070"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2 6.66699H14"
      stroke="#707070"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MModal = styled.div`
  position: fixed;
  z-index: 15;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #8d8d8de3;
  padding: 47px 20px;
`;
export const MModalHead = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 42px;
`;
export const MInputContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const MInput = styled.div`
  height: 40px;
  background: #ffffff;
  box-shadow: 0px 10px 30px rgba(77, 103, 193, 0.14902);
  border-radius: 5px;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 18px;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #707070;
`;
